import { TActions } from '../../../AppModulesWrapper';

import {
  CHANGE_AUTO_PROLONG,
  CHECK_SERVICE_FAIL,
  CHECK_SERVICE_START,
  CHECK_SERVICE_SUCCESS,
} from '../../actions/checkoutInfo';
import { LOAD_PUBLISH_TERMS_SUCCESS } from '../../actions/publishTerms';
import { RESET_STATE } from '../../actions/resetState';
import { ECheckServiceStatus, ICheckoutInfoState } from '../../types/reducers/checkoutInfo';
import { defaultAutoProlongInfo, defaultState } from './defaultState';

export function checkoutInfo(state: ICheckoutInfoState = defaultState, action: TActions): ICheckoutInfoState {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS: {
      return {
        ...state,
        autoProlongInfo: {
          ...state.autoProlongInfo,
          isChecked: action.payload.dataV2.paidPublication.autoProlong,
        },
      };
    }

    case CHECK_SERVICE_START: {
      return {
        ...state,
        status: ECheckServiceStatus.Pending,
        errorCode: null,
      };
    }

    case CHECK_SERVICE_SUCCESS: {
      const { autoProlongInfo, ...checkoutInfo } = action.payload;

      return {
        ...state,
        ...checkoutInfo,
        status: ECheckServiceStatus.Success,
        autoProlongInfo: {
          ...autoProlongInfo,
          isChecked: state.autoProlongInfo.isChecked,
        },
      };
    }

    case CHECK_SERVICE_FAIL: {
      return {
        ...defaultState,
        status: ECheckServiceStatus.Fail,
        errorCode: action.payload,
        autoProlongInfo: {
          ...defaultAutoProlongInfo,
          isChecked: state.autoProlongInfo.isChecked,
        },
      };
    }

    case CHANGE_AUTO_PROLONG: {
      return {
        ...state,
        autoProlongInfo: {
          ...state.autoProlongInfo,
          isChecked: action.payload,
        },
      };
    }

    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
}
